import { _ } from "../../../../core/polyglot/polyglot.js";
import { select } from "../../../../core/elements/index.js";
import popoverWidget from "../../../../core/widgets/popoverWidget/popoverWidget.js";

/**
 * Function attaching a {@link popoverWidget} to a `trigger` tag
 * brush. After the function has been called, clicking the trigger
 * will show a popover listing `periods` and letting the user open the
 * account statement on this period.
 *
 * @param {tagBrush} trigger - The account row link to which the
 *   popover should be attached
 * @param {string} accountNumber - Used for the popover's title and
 *   passed to `onAccountStatementRedirectionRequest`
 * @param {Period[]} periods - The possible periods that the account
 *   stament can be show for
 * @param {function} onAccountStatementRedirectionRequest - Will be
 *   called with `accountNumber` and the selected period if the user
 *   presses 'ok'
 */
export default function makeAccountStatementPopover({
	trigger,
	accountNumber,
	periods,
	onAccountStatementRedirectionRequest,
}) {
	const items = makeItems({ periods });

	let selectedElement = items[0].value;

	const periodPicker = (html) =>
		select({
			renderOn: html,
			items,
			selected: selectedElement,
			name: "period",
			onChange: (selected) => {
				selectedElement = selected;
			},
		});

	popoverWidget({
		triggerItem: trigger,
		popoverCssClass: "popover fade top",
		header: headerRenderer({ accountNumber }),
		content: [_("Select a period below"), periodPicker],
		primaryLabel: _("Show account statement"),
		primaryAction: () => {
			onAccountStatementRedirectionRequest({
				accountNumber,
				period: selectedElement.toString(),
			});
		},
	});
}

function headerRenderer({ accountNumber }) {
	return (html) => {
		html.span(
			html.strong(
				_("Account {number}", {
					number: accountNumber,
				}),
			),
		);
	};
}

function makeItems({ periods }) {
	return periods.map((period) => ({
		label: period.toSmartString(),
		value: period,
	}));
}
